import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { closeOrderNoteModal, orderNoteAdd } from '../actions/index';
import { Modal } from 'react-bootstrap';

class ModalOrderNote extends Component {
  constructor(props) {
    super(props);

    this.state = {
      orderNote: '',
    }
  }

  componentWillMount() {
    if (this.props.current_order.order_note !== '') {
      this.setState({ orderNote: this.props.current_order.order_note });
    }
  }

  handleOrderNoteChange = note => {
    this.setState({ orderNote: note });
  }

  handleAddOrderNote = () => {
    this.props.orderNoteAdd(this.state.orderNote);
    this.props.closeOrderNoteModal();
  }

  render() {
    return (
      <Modal show={this.props.modals.showOrderNoteModal} onHide={this.props.closeOrderNoteModal}>
        <Modal.Header closeButton>
          <Modal.Title>Enter Order Note</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <form>
            <div className="form-group">
              <textarea autoFocus className="form-control" onChange={event => this.handleOrderNoteChange(event.target.value)} value={this.state.orderNote}></textarea>
            </div>
          </form>
        </Modal.Body>
        <Modal.Footer>
          <button type="button" className="btn btn-secondary" onClick={this.props.closeOrderNoteModal}>Close</button>&nbsp;
          <button type="button" className="btn btn-primary" onClick={this.handleAddOrderNote}>Save Changes</button>
        </Modal.Footer>
      </Modal>
    );
  }
}

function mapStateToProps({ modals, current_order }) {
  return { modals, current_order };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators( { closeOrderNoteModal, orderNoteAdd }, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(ModalOrderNote);



// WEBPACK FOOTER //
// ./src/containers/modal_order_note.js